import { InfluencerProfileSponsoredPosts, InfluencerProfileSponsoredPostsProps } from '../shared';

export type InfluencerInstagramProfileSponsoredPostsProps = InfluencerProfileSponsoredPostsProps;

export const InfluencerInstagramProfileSponsoredPosts = (props: InfluencerInstagramProfileSponsoredPostsProps) => (
  <InfluencerProfileSponsoredPosts {...props} />
);
